import { useEffect } from 'react';
import i18n from '../i18n';
import { usePreferencesStore } from '../stores/preferencesStore';

export const I18nBridge: React.FC = () => {
  const language = usePreferencesStore((s) => s.language);

  useEffect(() => {
    if (i18n.language !== language) {
      void i18n.changeLanguage(language);
    }
  }, [language]);

  return null;
};

export default I18nBridge;
